import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import theme from '~/shared/styles/theme'

function TopSection() {
  const navigate = useNavigate()

  const handleApply = () => {
    navigate('/customer-service/inquiry/create', {
      state: { categoryValue: 'C0400008' },
    })
  }

  return (
    <Wrapper>
      <Title>기업 참가 안내</Title>
      <Desc>
        기업 참가자 분들!
        <br />
        기업 참가자도 일러스타 페스 행사에 참여하실 수 있습니다.
        <br />
        자세한 내용이 궁금하시다면, ‘신청하기’ 버튼을 눌러주세요.
      </Desc>
      <ApplyButton onClick={handleApply}>기업 참가 신청하기</ApplyButton>
    </Wrapper>
  )
}

export default TopSection

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 36px;
  align-items: flex-start;

  box-sizing: border-box;
  margin-top: 124px;

  @media ${theme.device.large} {
    gap: 20px;
    height: auto;
  }

  @media ${theme.device.medium} {
    gap: 24px;
    margin-top: 56px;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 42px;
  font-weight: 700;
  line-height: 59px;
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    font-size: 28px;
    line-height: 40px;
  }
`

const Desc = styled.p`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    width: 100%;
    height: auto;
    font-size: 16px;
    line-height: 28px;
  }
`

const ApplyButton = styled.button`
  width: 247px;
  height: 58px;

  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 33px;
  color: white;

  background-color: #313634;
  border-radius: 54px;

  @media ${theme.device.medium} {
    max-width: 189px;
    min-height: 48px;
    font-size: 18px;
    line-height: 25px;
  }
`
